<template>
  <div class="countdown">
    <template v-for="(item, idx) in preparedClock">
      <div class="countdown__item" :key="idx">
        {{ item }}
      </div>
      <div
        class="countdown__divider"
        :key="idx + item"
        v-if="idx + 1 < preparedClock.length"
      >
        :
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Countdown',
  props: {
    endTime: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      currentTime: null,
    };
  },
  watch: {
    endTime(val) {
      if (val) {
        this.initClock();
      }
    },
  },
  computed: {
    preparedClock() {
      if (!this.currentTime) {
        return '';
      }
      return Object.keys(this.currentTime).reduce((acc, item) => {
        if (item === 'total') {
          return acc;
        }
        acc.push(('0' + this.currentTime[item]).slice(-2));
        return acc;
      }, []);
    },
  },
  methods: {
    getTimeRemaining(endtime) {
      let t = Date.parse(endtime) - Date.parse(new Date());
      const seconds = Math.floor((t / 1000) % 60);
      const minutes = Math.floor((t / 1000 / 60) % 60);
      const hours = Math.floor((t / (1000 * 60 * 60)) % 24);
      const days = Math.floor(t / (1000 * 60 * 60 * 24));
      return {
        total: t,
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds,
      };
    },
    initClock() {
      const timeinterval = setInterval(() => {
        this.currentTime = this.getTimeRemaining(new Date(this.endTime * 1000));
        if (this.currentTime.total <= 0) {
          clearInterval(timeinterval);
          this.$emit('finish');
        }
      }, 1000);
    },
  },
  mounted() {
    this.initClock();
  },
};
</script>

<style lang="less">
.countdown {
  font-weight: 300;
  font-size: 40px;
  line-height: 40px;
  font-style: italic;
  display: flex;
  color: var(--v-appMain-base);

  &__item {
  }
}
</style>
